/**
 * Do not edit directly
 * Generated on Tue, 23 Jul 2024 13:51:28 GMT
 */

module.exports = {
  "radiusBase": "8px",
  "radiusCircle": "50%",
  "radiusModal": "8px",
  "radiusPill": "100px",
  "widthBase": "1px"
};